export default "/images/vendor/flag-icon-css/flags/1x1/hm.svg?8b4c33d4098f83d3cddd6953707af769";